export default __webpack_public_path__ + "static/media/doctor-verified-badge.e787f1c8.svg";